import React from 'react';
import PricingCalculator from '../components/PricingCalculator';
import { motion } from 'framer-motion';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-white selection:bg-indigo-100 selection:text-indigo-900">
      <main>
        {/* Simple Header for Brand Identity */}
        

        <PricingCalculator />
        
        {/* Minimal Footer Info */}
        
      </main>
    </div>
  );
};

export default PricingPage;